export const domain =
  process.env.REACT_APP_SECRET_CODE === 'production'
    ? 'https://inall.ijianshui.com'
    : 'http://test-inall.ijianshui.com'
